export default __webpack_public_path__ + "static/media/search.5d87e168.svg";